import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type {
	NotiFicationButton,
	NotiFicationDatum
} from '../../config/notifications'

interface MessageState extends Omit<NotiFicationDatum, 'button'> {
	button: NotiFicationButton | null
	open: boolean
}

const INITIAL_MESSAGE: MessageState = {
	button: null,
	content: '',
	open: false,
	style: 'default',
	title: ''
}

interface NotificationState extends RootNotification {
	message: MessageState
}

interface RootNotification {
	error: boolean
	status: boolean
	text: string
}

const initialState: NotificationState = {
	error: true,
	message: INITIAL_MESSAGE,
	status: false,
	text: ''
}

const slice = createSlice({
	initialState,
	name: 'notification',
	reducers: {
		notificationUse(state, action: PayloadAction<RootNotification>) {
			state.error = action.payload.error
			state.status = action.payload.status
			state.text = action.payload.text
		},

		resetSnack(state) {
			state.message = INITIAL_MESSAGE
		},

		showSnack(state, action: PayloadAction<NotiFicationDatum>) {
			state.message = {
				...state.message,
				...action.payload,
				button: action.payload.button ?? null,
				open: true
			}
		}
	},

	selectors: {
		error: state => state.error,
		message: state => state.message,
		snackOpen: state => state.message.open,
		snackStyle: state => state.message.style,
		status: state => state.status,
		text: state => state.text
	}
})

const actions = slice.actions
const selectors = slice.selectors

export { actions, selectors, slice }
